module.exports = __webpack_public_path__ + "static/media/t_nor_02.3259bbdf.png";